<div class="modal-wrapper">
  <form [formGroup]='exportForm' (submit)='onSubmit()' novalidate>
    <div *ngIf='!loader; else showLoader'>
      <div class="modal-header">
        <div class="modal-header-content">
          <h1 class="modal-title"> {{title}}</h1>
          <p class="modal-subtitle">{{subtitle}}</p>
        </div>
        <i class="ic-close icon-size-32" (click)="activeModal.dismiss('Cross click')"></i>
      </div>
      <div class="modal-body">
        <div class="form-container">
          <div class="form-group" >
            <label
              for='item'
              class="input-title"
            >{{inputTitle}}</label>
            <ng-select 
              [clearable]="false"
              [multiple]="true"
              [closeOnSelect]='false'
              class="custom multiselect"
              formControlName='item'
              [searchable]="false"
              placeholder='Select an option...'
              [items]="itemsList"
              (remove)='onCloseSelect()'
              (close)='onCloseSelect()'
            >
            <ng-template ng-header-tmp>
              <button
                type="button"
                *ngIf="itemsList?.length > 0"
                [class.ng-option-selected]='export.item.value.length === itemsList?.length'
                class="btn select-all-btn ng-option"
                (click)="onSelectAll()"
              ><span class="ng-option-label">All</span>
              </button>
            </ng-template>
            </ng-select>
          </div>
          <div class="extra-info-container" *ngIf="selectedSubtoolDetailsFiltered?.length > 0">
            <p class="tab-description">For each subtool, choose the datas you want to export.</p>
            <ul [(activeId)]="activeIndexTab" ngbNav #nav="ngbNav" class="tabs-wrapper">
              <li [ngbNavItem]='i' *ngFor='let tab of selectedSubtoolDetailsFiltered; let i = index' class="tabs-container">
                <a
                  class="btn single-tab {{i === activeIndexTab ? 'active border-' + currentTool : ''}}"
                  ngbNavLink
                >{{tab.name}}</a>
                <ng-template ngbNavContent>
                  <div class="form-group" *ngIf="selectedSubtoolDetailsFiltered[i]?.views?.length > 0">
                    <label
                      for='view'
                      class="input-title"
                    >View</label>
                    <ng-select
                      bindLabel='name'
                      bindValue='value'
                      groupBy='aggregation'
                      [clearable]="false"
                      class="custom select-check-value ng-select ng-select-single"
                      [formControlName]='getDetailId(tab.name, "view")'
                      [searchable]="false"
                      placeholder='Select an option...'
                      (change)='getSelectedValue(tab.name)'
                      [items]="selectedSubtoolDetailsFiltered[i].views"
                    >
                    </ng-select>
                  </div>
                  <div class="form-group" 
                  *ngIf="selectedSubtoolDetailsFiltered[i]?.scenarios != null && selectedSubtoolDetailsFiltered[i]?.scenarios?.length > 0">
                    <label
                      for='scenarios'
                      class="input-title"
                    >Scenarios</label>
                    <ng-select
                      bindLabel='name'
                      bindValue='value'
                      groupBy='aggregation'
                      [clearable]="false"
                      class="custom select-check-value ng-select ng-select-single"
                      [formControlName]='getDetailId(tab.name, "scenario")'
                      [searchable]="false"
                      placeholder='Select an option...'
                      [items]="selectedSubtoolDetailsFiltered[i]?.scenarios"
                    >
                    </ng-select>
                  </div>
                  <div class="form-group" *ngIf="selectedSubtoolDetailsFiltered[i]?.isins?.length > 0">
                    <label
                      for='isins'
                      class="input-title"
                    >ISIN</label>
                    <ng-select
                    bindLabel='name'
                    bindValue='value'
                    groupBy='aggregation'
                    [clearable]="false"
                    class="custom select-check-value ng-select ng-select-single"
                    [formControlName]='getDetailId(tab.name, "isin")'
                    [searchable]="false"
                    placeholder='Select an option...'
                    [items]="selectedSubtoolDetailsFiltered[i]?.isins"
                  >
                  </ng-select>
                    <!-- <div class="isin-container" [attr.for]="'isins' + i">
                      <span
                        class="btn selected"
                        *ngFor="let item of export['isins' + i]?.value">
                        <span class="close-selected" (click)="close(item, i)">&nbsp;x</span>
                        {{item}}
                      </span>
                      <input
                        #input
                        [id]="'isins' + i"
                        type="text"
                        class="input form-control"
                        [ngbTypeahead]="search"
                        (selectItem)="selected($event, i)"
                      />
                    </div> -->
                  </div>
                </ng-template>
              </li>
            </ul>
            <div [ngbNavOutlet]="nav"></div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="activeModal.dismiss('Cross click')">Cancel</button>
        <button class="btn btn-default ml-3" [disabled]="exportForm.invalid || !hasLoadedAllControls">Download</button>
      </div>
    </div>
    <ng-template #showLoader>
      <div class="loader-container" *ngIf="loader">
        <div class="download-loader">
          <p>{{downloadProgress.title}}</p>
          <!-- <div class="spinner-border"></div> -->
          <ngb-progressbar
          type="success"
          [striped]="downloadProgress.state === 'PENDING'" 
          [animated]="downloadProgress.state === 'PENDING'" 
          [value]="downloadProgress.state === 'PENDING'? 100 : downloadProgress.progress">
          {{progress | percent:'1.2-2'}}
          </ngb-progressbar>
        </div>
      </div>
    </ng-template>
  </form>
</div>
  